import React, { useEffect, useState } from "react";
import BriefingTable from "../subcomponents/table";
import { TextField } from "../subcomponents/fields";
import { fetchRows as fetchData } from "../helpers";
import { CRUDRow } from "../helpers";
import Actions from "../subcomponents/actions";  // Fixed typo (Actoins -> Actions)
import toast from "react-hot-toast";
import HistoryViewer from "../subcomponents/historyViewer";
import { useSelector } from "react-redux";

const CriticalDrivers = () => {
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);

    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    const requestPayload = {
        "startDate": startDate,
        "endDate": endDate,
        "searchTerm": searchTerm
    }

    const DataURL = "admin/briefing/get_critical_drivers";
    const RowURL = "admin/briefing/critical_driver_row";

    useEffect(() => {
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            const data = await fetchData(DataURL, briefing, requestPayload);
            setData(data);
        })();
    }, [refresh, startDate, endDate, searchTerm, briefing]);

    // Function to create a new row and refresh the table
    const lCrudRow = async (action = "create", rowID = null) => {
        await CRUDRow(RowURL, action, rowID);
        // Re-fetch data after modifying the row
        const data = await fetchData(DataURL);
        setData(data);
    };

    const headers = [
        "ID",
        "Names",
        "Last Avail.",
        "City",
        "State",
        'Act.'
    ];

    const renderRow = (row) => (
        <>
            <tr key={row.id}>
                <td className="row-id-cell">
                    <div className="row-id-div">
                        {row.id}
                    </div>
                </td>
                <td>
                    <TextField field={row.name} />
                </td>
                <td>
                    <TextField
                        field={row.last_available}
                        inputFilter={{
                            filter: (targetValue) => { if (!targetValue || targetValue >= 0 && targetValue <= 200) { return true } },
                            message: "Valid input between 0-200"
                        }}
                        onBackendSync={() => setRefresh(!refresh)}
                    />
                </td>
                <td>
                    <TextField field={row.city} />
                </td>
                <td>
                    <TextField field={row.state} />
                </td>
                <td className="actions-cell">
                    <Actions
                        onDelete={() => lCrudRow("delete", row.id)}
                        onArchive={() => lCrudRow("archive", row.id)}
                    />
                </td>
            </tr>
        </>
    );

    if (briefing === "Old Briefings" && !data.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Available Drivers
                </h2>
                <HistoryViewer
                    url={DataURL}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={data}
                renderRow={renderRow}
                createRow={lCrudRow}
            />
        </>
    );
};

export default CriticalDrivers;
